export default __webpack_public_path__ + "3b48d9e530ef2779d40088beded1ef77.jpeg";